import { themed } from '@heathmont/moon-utils';
import styled from 'styled-components';
import inlineMixin from '../inlineMixin/inlineMixin';
const Inline = styled.div(({ fontSize, justifyContent, space = 'default', theme }) => (Object.assign(Object.assign({}, inlineMixin(themed('space', space)(theme), justifyContent)), { fontSize })));
export default Inline;
